// Hazır marka renkleri (Tailwind paletleri). Uygulamadaki "emerald" sınıfları bu değişkenlere bağlıdır.
const SHADES = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

const PALETTES = {
  emerald: ['ecfdf5', 'd1fae5', 'a7f3d0', '6ee7b7', '34d399', '10b981', '059669', '047857', '065f46', '064e3b', '022c22'],
  teal: ['f0fdfa', 'ccfbf1', '99f6e4', '5eead4', '2dd4bf', '14b8a6', '0d9488', '0f766e', '115e59', '134e4a', '042f2e'],
  cyan: ['ecfeff', 'cffafe', 'a5f3fc', '67e8f9', '22d3ee', '06b6d4', '0891b2', '0e7490', '155e75', '164e63', '083344'],
  sky: ['f0f9ff', 'e0f2fe', 'bae6fd', '7dd3fc', '38bdf8', '0ea5e9', '0284c7', '0369a1', '075985', '0c4a6e', '082f49'],
  blue: ['eff6ff', 'dbeafe', 'bfdbfe', '93c5fd', '60a5fa', '3b82f6', '2563eb', '1d4ed8', '1e40af', '1e3a8a', '172554'],
  indigo: ['eef2ff', 'e0e7ff', 'c7d2fe', 'a5b4fc', '818cf8', '6366f1', '4f46e5', '4338ca', '3730a3', '312e81', '1e1b4b'],
  violet: ['f5f3ff', 'ede9fe', 'ddd6fe', 'c4b5fd', 'a78bfa', '8b5cf6', '7c3aed', '6d28d9', '5b21b6', '4c1d95', '2e1065'],
  rose: ['fff1f2', 'ffe4e6', 'fecdd3', 'fda4af', 'fb7185', 'f43f5e', 'e11d48', 'be123c', '9f1239', '881337', '4c0519'],
  orange: ['fff7ed', 'ffedd5', 'fed7aa', 'fdba74', 'fb923c', 'f97316', 'ea580c', 'c2410c', '9a3412', '7c2d12', '431407'],
  amber: ['fffbeb', 'fef3c7', 'fde68a', 'fcd34d', 'fbbf24', 'f59e0b', 'd97706', 'b45309', '92400e', '78350f', '451a03'],
};

export const BRAND_COLOR_OPTIONS = [
  { key: 'emerald', label: 'Zümrüt Yeşili' },
  { key: 'teal', label: 'Deniz Yeşili' },
  { key: 'cyan', label: 'Turkuaz' },
  { key: 'sky', label: 'Gök Mavisi' },
  { key: 'blue', label: 'Mavi' },
  { key: 'indigo', label: 'Lacivert' },
  { key: 'violet', label: 'Mor' },
  { key: 'rose', label: 'Gül Kırmızısı' },
  { key: 'orange', label: 'Turuncu' },
  { key: 'amber', label: 'Kehribar' },
].map(o => ({ ...o, hex: `#${PALETTES[o.key][6]}` }));

const toRgb = (hex) => [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16)).join(' ');

export const applyBrandColor = (key) => {
  const palette = PALETTES[key] || PALETTES.emerald;
  const root = document.documentElement.style;
  SHADES.forEach((s, i) => root.setProperty(`--brand-${s}`, toRgb(palette[i])));
  return `#${palette[6]}`;
};
